<template>
  <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
    <!--begin::Toolbar-->
    <div class="toolbar" id="kt_toolbar">
      <!--begin::Container-->
      <app-sub-header :title="title" :breadcrumbs="breadcrumbs" :back="true">
        <!-- DRAFT uniquement : Modifier -->
        <button
          v-if="purchase.status === 'DRAFT'"
          @click.prevent="$router.push({ name: 'suppliers-purchases-edit', params: { id: $route.params.id } })"
          class="btn btn-sm btn-flex btn-light-primary btn-active-primary fw-bolder me-2">
          {{ $t("purchase.edit") }}
        </button>
        <!-- DRAFT uniquement : Envoyer au fournisseur -->
        <button
          v-if="purchase.status === 'DRAFT'"
          class="btn btn-sm btn-flex btn-primary fw-bolder me-2"
          :disabled="isStart"
          @click.prevent="sendOrderInvoice">
          {{ $t("purchase.send") }}
        </button>
        <!-- DRAFT ou SENT : Réceptionner -->
        <button
          v-if="['DRAFT', 'SENT'].includes(purchase.status)"
          @click.prevent="$router.push({ name: 'suppliers-purchases-validate', params: { id: $route.params.id } })"
          class="btn btn-sm btn-flex btn-light-warning btn-active-warning fw-bolder me-2">
          {{ $t("purchase.receive_order") }}
        </button>
        <!-- RECEIVED uniquement : Valider -->
        <button
          v-if="purchase.status === 'RECEIVED'"
          @click.prevent="$router.push({ name: 'suppliers-purchases-validate', params: { id: $route.params.id } })"
          class="btn btn-sm btn-flex btn-primary fw-bolder me-2">
          {{ $t("purchase.validate") }}
        </button>
        <!-- Toujours : Télécharger PDF -->
        <button
          class="btn btn-sm btn-flex btn-light-primary btn-active-primary fw-bolder me-2"
          :disabled="isStart"
          @click.prevent="downloadButton">
          {{ $t("purchase.download") }}
        </button>
      </app-sub-header>
      <!--end::Container-->
    </div>
    <!-- end::Toolbar -->

    <div class="container-xxl" v-if="isLoading">
      <Loader />
    </div>

    <div v-else class="post d-flex flex-column-fluid" id="kt_post">
      <div id="kt_content_container" class="container-xxl" style="margin-bottom: 50px!important;">
        <div class="card">
          <div id="purchase-content" class="card-body py-5">
            <div class="mw-lg-950px mx-auto w-100">
              <div class="d-flex justify-content-between flex-column flex-sm-row mb-9">
                <div class="w-25">
                  <img alt="Logo" :src="companyInfo?.logo_url || '/assets/media/logos/qomerxia-logo.png'" class="h-45px logo" style="max-width:150px;object-fit:contain;" />
                </div>
                <div class="flex-grow-1">
                  <div class="row g-4">
                    <div class="col-6">
                      <div class="purchase-party-box">
                        <div class="purchase-party-label">{{ $t('purchase.issuer') }}</div>
                        <div class="fw-boldest text-gray-800 fs-5">{{ companyInfo?.society }}</div>
                        <div v-if="companyInfo?.address || companyInfo?.city">
                          {{ [companyInfo?.address, companyInfo?.city].filter(Boolean).join(', ') }}
                          <span v-if="companyInfo?.country?.name">, {{ companyInfo.country.name }}</span>
                        </div>
                        <div v-if="companyInfo?.society_phone">{{ $t('tel') }} : {{ companyInfo.society_phone }}</div>
                        <div v-if="companyInfo?.ifu_number">IFU : {{ companyInfo.ifu_number }}</div>
                        <div v-if="companyInfo?.rccm_number">RCCM : {{ companyInfo.rccm_number }}</div>
                      </div>
                    </div>
                    <div class="col-6" v-if="purchase.customer">
                      <div class="purchase-party-box">
                        <div class="purchase-party-label">{{ $t('purchase.supplier_name') }}</div>
                        <div class="fw-boldest text-gray-800 fs-5">{{ purchase?.customer?.gender_full_name }}</div>
                        <div v-if="purchase.customer?.email">{{ purchase.customer.email }}</div>
                        <div v-if="purchase.customer?.phones">{{ $t('tel') }} : {{ purchase.customer.phones }}</div>
                        <div v-if="purchase.customer?.first_address_infos">{{ purchase.customer.first_address_infos }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pb-12">
                <div class="d-flex flex-column gap-7 gap-md-10">
                  <div class="separator"></div>
                  <div class="d-flex flex-column flex-sm-row gap-7 gap-md-10 fw-bolder">
                    <div class="flex-root d-flex flex-column">
                      <span class="text-muted">{{ $t('contacts.order_number') }}</span>
                      <span class="fs-5">{{ purchase.number }}</span>
                    </div>
                    <div class="flex-root d-flex flex-column">
                      <span class="text-muted">Date</span>
                      <span class="fs-5">{{ purchase.date }}</span>
                    </div>
                  </div>

                  <div class="d-flex justify-content-between flex-column">
                    <div class="table-responsive border-bottom mb-9">
                      <table class="table align-middle table-row-dashed fs-6 gy-5 mb-0">
                        <thead>
                          <tr class="border-bottom fs-6 fw-bolder text-muted">
                            <th class="min-w-50px pb-2">{{ $t('N°') }}</th>
                            <th class="min-w-175px pb-2">{{ $t('shop.products') }}</th>
                            <th class="min-w-80px text-end pb-2">{{ $t('store.entrie.quantity') }}</th>
                            <th class="min-w-70px text-end pb-2">{{ $t('shop.unit_price') }}</th>
                            <th class="min-w-70px text-end pb-2">{{ $t('purchase.tax') }}</th>
                            <th class="min-w-100px text-end pb-2">{{ $t('shop.total') }}</th>
                          </tr>
                        </thead>
                        <tbody class="fw-bold text-gray-600">
                          <tr v-for="(product, index) in purchase.order_contents" :key="index">
                            <td class="td_customize">
                              {{ index + 1 }}
                            </td>
                            <td class="td_customize">
                              <div class="d-flex align-items-center">
                                <div>
                                  <div class="fw-bolder"> {{ product.product_name }}</div>
                                </div>
                              </div>
                            </td>
                            <td class="text-end td_customize">{{ (product.quantity || "0") }} {{ product?.lot ? 'LOT('+product.lot.item_number+')' : 'U' }}</td>
                            <td class="text-end td_customize"> {{ product.purchase_price ? $formatLocalAmount(parseFloat(product.purchase_price)) + ' ' + purchase?.currency_iso : 0 }}</td>
                            <td class="text-end td_customize">
                              <span v-if="product.order_content_taxes.length">
                                {{ $formatLocalAmount(invoiceProductTaxesTotal(product.order_content_taxes)) + ' ' + purchase?.currency_iso }}
                              </span>
                              <span v-else>---</span>
                            </td>
                            <td class="text-end td_customize"> {{ $formatLocalAmount(totalProductPrice(product)) + ' ' + purchase?.currency_iso }}</td>
                          </tr>
                          <tr>
                            <td colspan="5" class="text-end">{{ $t('purchase.sub_total') }}</td>
                            <td class="text-end"> {{ $formatLocalAmount(parseFloat(invoiceSubTotal)) + ' ' + purchase?.currency_iso }}</td>
                          </tr>
                          <tr>
                            <td colspan="5" class="text-end">{{ $t('purchase.tax') }}</td>
                            <td class="text-end"> {{ $formatLocalAmount(parseFloat(invoiceTaxesTotal)) + ' ' + purchase?.currency_iso }}</td>
                          </tr>
                          <tr>
                            <td colspan="5" class="text-end">{{ $t('purchase.total_ttc') }}</td>
                            <td class="text-end"> {{ $formatLocalAmount(parseFloat(invoiceSubTotal + invoiceTaxesTotal)) + ' ' + purchase?.currency_iso }}</td>
                          </tr>
                          <tr>
                            <td colspan="5" class="text-end">{{ $t('purchase.total_fee') }}</td>
                            <td class="text-end"> {{ $formatLocalAmount(parseFloat(totalFee)) + ' ' + purchase?.currency_iso }}</td>
                          </tr>
                          <tr>
                            <td colspan="5" class="fs-3 text-dark fw-bolder text-end">{{ $t('purchase.amount') }}</td>
                            <td class="text-dark fs-2x fw-boldest text-end"> {{ $formatLocalAmount(parseFloat(invoiceTotal)) + ' ' + purchase?.currency_iso }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Timeline historique -->
      <div class="container-xxl mt-4" style="margin-bottom: 50px!important;" v-if="purchase?.order_histories?.length">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-8">
            <div class="card">
              <div class="card-header border-0 pt-5 pb-0 min-h-auto">
                <h3 class="card-title fw-bolder text-dark fs-6">{{ $t('purchase.history') }}</h3>
              </div>
              <div class="card-body pt-3 pb-4">
                <div class="timeline-label">
                  <div class="timeline-item" v-for="(entry, idx) in purchase.order_histories" :key="idx">
                    <div class="timeline-label fw-bold text-gray-800 fs-7 w-auto pe-4" style="min-width:75px">
                      {{ formatHistoryTime(entry.created_at) }}
                    </div>
                    <div class="timeline-badge">
                      <i :class="['fa fa-genderless fs-1', historyIconClass(entry.new_status)]"></i>
                    </div>
                    <div class="timeline-content fw-semibold text-gray-800 ps-3 fs-7">
                      <span v-if="entry.old_status_format">
                        Statut changé de
                        <strong class="text-warning">« {{ entry.old_status_format }} »</strong>
                        à
                        <strong class="text-success">« {{ entry.new_status_format }} »</strong>
                      </span>
                      <span v-else>
                        {{ $t('purchase.history_created') }}
                        <strong class="text-success">« {{ entry.new_status_format }} »</strong>
                      </span>
                      <span class="text-muted ms-2" v-if="entry.user?.fullname">
                        — {{ $t('purchase.history_by') }} <strong>{{ entry.user.fullname }}</strong>
                      </span>
                      <div class="text-muted fs-8">{{ formatHistoryDate(entry.created_at) }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- Modal de composition d'email -->
  <div v-if="showEmailModal" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title fw-bolder">{{ $t('purchase.compose_email_modal_title') }}</h5>
          <button type="button" class="btn-close" @click="showEmailModal = false"></button>
        </div>
        <div class="modal-body">
          <div class="mb-4">
            <label class="form-label fw-bold required">{{ $t('purchase.email_to') }}</label>
            <input id="kt_tagify_to" class="form-control" type="text" :placeholder="$t('purchase.email_cc_placeholder')" />
            <small class="text-muted">{{ $t('purchase.email_cc_hint') }}</small>
          </div>
          <div class="mb-4">
            <label class="form-label fw-bold">{{ $t('purchase.email_cc') }}</label>
            <input id="kt_tagify_cc" class="form-control" type="text" :placeholder="$t('purchase.email_cc_placeholder')" />
            <small class="text-muted">{{ $t('purchase.email_cc_hint') }}</small>
          </div>
          <div class="mb-4">
            <label class="form-label fw-bold required">{{ $t('purchase.email_subject') }}</label>
            <input
              type="text"
              class="form-control"
              v-model="emailFormData.subject"
              required
            />
          </div>
          <div class="mb-4">
            <label class="form-label fw-bold">{{ $t('purchase.email_message') }}</label>
            <textarea
              class="form-control"
              v-model="emailFormData.message"
              rows="9"
            ></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" @click="showEmailModal = false">
            {{ $t('cancel') }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            :disabled="isSending || !toList.length"
            @click="confirmSendEmail">
            <span v-if="isSending" class="spinner-border spinner-border-sm me-2"></span>
            {{ $t('purchase.send_email') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import AppSubHeader from "./Partials/AppSubHeader.vue";
import Loader from "@/components/Loader.vue";
import { computed, onMounted, onActivated, nextTick, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";


const store = useStore()
const route = useRoute()

const title = ref("breadcrumbs.purchase.title")
const breadcrumbs = ref([
  {
    name: 'breadcrumbs.purchase.list',
    path: '/admin/suppliers/purchases'
  },
  {
    name: 'breadcrumbs.purchase.detail',
    path: '/admin/suppliers/purchases/view/:id'
  }
])
const isLoading = ref(false)

const purchase = computed(() => store.getters['orders/currentOrder'])
const companyInfo = computed(() => store.getters['user/getCompanyInfo'])
const lots = computed(() => store.getters['products/getLots'])

async function loadData() {
  await store.dispatch('user/companyInfo')
  await store.dispatch('taxes/loadTaxes')
  await store.dispatch('orders/getOrderById', route.params.id)
  await store.dispatch('products/listProductLots')
}

const canTransfer = ref(false)
const isStart = ref(false)
const isSending = ref(false)
const showEmailModal = ref(false)
const toList = ref([])
const ccList = ref([])
const emailFormData = ref({
  to: '',
  subject: '',
  message: '',
})

let tagifyTo = null
let tagifyCc = null

watch(showEmailModal, async (opened) => {
  if (opened) {
    await nextTick()

    const toInput = document.getElementById('kt_tagify_to')
    if (toInput) {
      tagifyTo = new Tagify(toInput, {
        pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        delimiters: ',',
      })
      tagifyTo.on('add', () => { toList.value = tagifyTo.value.map(x => x.value) })
      tagifyTo.on('remove', () => { toList.value = tagifyTo.value.map(x => x.value) })
      if (emailFormData.value.to) {
        tagifyTo.addTags([emailFormData.value.to])
      }
    }

    const ccInput = document.getElementById('kt_tagify_cc')
    if (ccInput) {
      tagifyCc = new Tagify(ccInput, {
        pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        delimiters: ',',
      })
      tagifyCc.on('add', () => { ccList.value = tagifyCc.value.map(x => x.value) })
      tagifyCc.on('remove', () => { ccList.value = tagifyCc.value.map(x => x.value) })
    }
  } else {
    tagifyTo?.destroy()
    tagifyTo = null
    toList.value = []
    tagifyCc?.destroy()
    tagifyCc = null
    ccList.value = []
  }
})

watch(() => purchase.value, (newValue) => {
  canTransfer.value = newValue.order_contents.some(content => content.stock_variable > 0)
})

function totalProductPrice(itemData) {
  let totalPrice = itemData.purchase_price * itemData.quantity;
  if(itemData.lot_id){
    const lot = lots.value.find(lot => lot.id === itemData.lot_id)
    if(lot)
      totalPrice = itemData.purchase_price * itemData.quantity * lot.lot.item_number
  }
  if (itemData.order_content_taxes.length > 0) {
    const totalTaxePrice = itemData.order_content_taxes.reduce((accumulator, tax) => {
      if (tax.taxe.type === 'amount') {
        accumulator.accAmount += parseFloat(tax.taxe.amount);
      } else {
        accumulator.accPercent += (totalPrice * parseFloat(tax.taxe.amount) / 100);
      }
      return accumulator;
    }, { accAmount: 0, accPercent: 0 });
    return totalPrice + totalTaxePrice.accAmount + totalTaxePrice.accPercent;
  }
  return parseFloat(totalPrice).toFixed(2);
}

const invoiceSubTotal = computed(() => {
  let total = 0
  if (purchase.value?.order_contents?.length > 0) {
    for (const itemData of purchase.value.order_contents) {
      let totalPrice = itemData.quantity * itemData.purchase_price
      if(itemData.lot_id){
        const lot = lots.value.find(lot => lot.id === itemData.lot_id)
        if(lot)
          totalPrice = itemData.purchase_price * itemData.quantity * lot.lot.item_number
      }
      if (itemData.order_content_taxes.length > 0) {
        const totalTaxePrice = itemData.order_content_taxes.reduce((accumulator, tax) => {
          if (tax.taxe.type === 'amount') {
            accumulator.accAmount += parseFloat(tax.taxe.amount);
          } else {
            accumulator.accPercent += (totalPrice * parseFloat(tax.taxe.amount) / 100);
          }
          return accumulator
        }, { accAmount: 0, accPercent: 0 })
        totalPrice += totalTaxePrice.accAmount + totalTaxePrice.accPercent
      }
      total += totalPrice
    }
  }
  return total
})

const invoiceTaxesTotal = computed(() => {
  let total = 0
  if (purchase.value?.order_taxes?.length > 0) {
    
    const orderTaxesSelected = purchase.value.order_taxes
    let invoiceTota = invoiceSubTotal.value
    if (orderTaxesSelected.length > 0) {
      const totalTaxePrice = orderTaxesSelected.reduce((accumulator, tax) => {
        if (tax.taxe.type === 'amount') {
          accumulator.accAmount += parseFloat(tax.taxe.amount);
        } else {
          accumulator.accPercent += (invoiceTota * parseFloat(tax.taxe.amount) / 100);
        }
        return accumulator
      }, { accAmount: 0, accPercent: 0 })
      total = totalTaxePrice.accAmount + totalTaxePrice.accPercent
    }
  }
  return total
})

function invoiceProductTaxesTotal(taxes) {
  let total = 0
  if (taxes?.length > 0) {
    const orderTaxesSelected = taxes
    let invoiceTota = invoiceSubTotal.value
    if (orderTaxesSelected.length > 0) {
      const totalTaxePrice = orderTaxesSelected.reduce((accumulator, tax) => {
        if (tax.taxe.type === 'amount') {
          accumulator.accAmount += parseFloat(tax.taxe.amount);
        } else {
          accumulator.accPercent += (invoiceTota * parseFloat(tax.taxe.amount) / 100);
        }
        return accumulator
      }, { accAmount: 0, accPercent: 0 })
      total = totalTaxePrice.accAmount + totalTaxePrice.accPercent
    }
  }
  return parseFloat(total).toFixed(2)
}

const totalFee = computed(() => {
  let total = 0
  if (purchase.value?.other_fees?.length > 0) {
    for (const fee of purchase.value.other_fees) {
      if (isNaN(parseFloat(fee.price))) {
        total += 0
      } else {
        total += parseFloat(fee.price)
      }
    }
  }
  return total
})

const invoiceTotal = computed(() => {
  return invoiceSubTotal.value + invoiceTaxesTotal.value + totalFee.value
})

async function downloadButton() {
  isStart.value = true
  await store.dispatch('orders/downloadOrderPdf', purchase.value.id)
    .then(response => {
      window.toastr['success'](i18n.global.t('notification.order_created_success'))
    })
    .catch(err => {
      window.toastr['error'](i18n.global.t('notification.order_created_error'))
    })
    isStart.value = false
}

function sendOrderInvoice() {
  ccList.value = []
  tagifyCc?.removeAllTags()
  emailFormData.value = {
    to: purchase.value?.customer?.email ?? '',
    subject: `Bon de commande N° ${purchase.value?.number} — ${companyInfo.value?.society ?? ''}`,
    message: `Madame, Monsieur,\n\nVeuillez trouver ci-joint notre bon de commande N° ${purchase.value?.number} du ${purchase.value?.date}.\n\nCordialement,\n${companyInfo.value?.society ?? ''}`,
  }
  showEmailModal.value = true
}

async function confirmSendEmail() {
  // Construits directement à partir des tags confirmés + du texte encore en
  // cours de saisie (non validé par une virgule/Entrée) — sans dépendre de
  // l'event 'add' de Tagify pour rafraîchir la valeur avant l'envoi, ce qui
  // pouvait perdre l'adresse tout juste tapée (le "cc" saisi mais jamais
  // envoyé, comme si seul le "to" existait).
  const toEmails = tagifyTo ? tagifyTo.value.map(x => x.value) : (emailFormData.value.to ? [emailFormData.value.to] : [])
  const pendingTo = tagifyTo?.DOM?.input?.value?.trim()
  if (pendingTo) toEmails.push(pendingTo)

  const ccEmails = tagifyCc ? tagifyCc.value.map(x => x.value) : [...ccList.value]
  const pendingCc = tagifyCc?.DOM?.input?.value?.trim()
  if (pendingCc) ccEmails.push(pendingCc)

  if (!toEmails.length) return

  isSending.value = true
  try {
    await store.dispatch('orders/sendOrder', {
      id: purchase.value.id,
      ...emailFormData.value,
      to: toEmails.join(', '),
      cc: ccEmails.join(', '),
    })
    window.toastr['success'](i18n.global.t('notification.order_created_success'))
    showEmailModal.value = false
  } catch {
    window.toastr['error'](i18n.global.t('notification.order_created_error'))
  } finally {
    isSending.value = false
  }
}

function historyIconClass(status) {
  const map = {
    DRAFT:     'text-secondary',
    SENT:      'text-primary',
    RECEIVED:  'text-warning',
    VALIDATED: 'text-success',
    CANCELED:  'text-danger',
    REJECTED:  'text-danger',
  }
  return map[status] ?? 'text-secondary'
}

function formatHistoryTime(dateStr) {
  if (!dateStr) return ''
  return new Date(dateStr).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
}

function formatHistoryDate(dateStr) {
  if (!dateStr) return ''
  return new Date(dateStr).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

onMounted(() => {
  isLoading.value = true
  Promise.all([
    loadData()
  ])
    .then(res => isLoading.value = false)
    .catch(err => isLoading.value = false)
})

// Déclenché quand on revient sur la vue via keep-alive (ex: retour de Validate.vue)
onActivated(() => {
  store.dispatch('orders/getOrderById', route.params.id)
})

</script>

<style scoped>
.light-danger {
  color: #f1416c;
  border-color: #fff5f8;
  background-color: #fff5f8;
  font-size: .925rem;
  border-radius: 0.325rem;
  padding: 5px 10px;
}

.light-primary {
  color: #0b3d87;
  border-color: #f1faff;
  background-color: #f1faff;
  font-size: .925rem;
  border-radius: 0.325rem;
  padding: 5px 10px;
}

.td_customize{
  padding-top: 2.5rem !important;
  padding-bottom: 2.5rem !important;
}

.purchase-party-box {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #f9fafb;
  padding: 14px 16px;
  height: 100%;
  line-height: 1.6;
}

.purchase-party-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #0b3d87;
  margin-bottom: 6px;
}
</style>